'use client'

import { ScrollProgressBar, useScrollState } from '@/shared/lib'

export const MobileScrollProgressBar = () => {
  const { ref: scrollContainerRef } = useScrollState()

  return (
    <ScrollProgressBar
      scrollContainerRef={scrollContainerRef}
      className="absolute top-full right-0"
    />
  )
}
